'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var index$1 = require('../../../atoms/Button/index.js');
var index = require('../store/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var WizardActions = function WizardActions(_ref) {
  var backButton = _ref.backButton,
      finishButton = _ref.finishButton,
      forwardButton = _ref.forwardButton;

  var _useContext = React.useContext(index.default),
      isFirstStep = _useContext.isFirstStep,
      isLastStep = _useContext.isLastStep,
      onGoBack = _useContext.onGoBack,
      onGoForward = _useContext.onGoForward;

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-wizard-actions"
  }, /*#__PURE__*/React__default['default'].createElement(index$1, {
    disabled: isFirstStep,
    secondary: true,
    onSelect: onGoBack
  }, backButton), /*#__PURE__*/React__default['default'].createElement(index$1, {
    onSelect: onGoForward
  }, isLastStep ? finishButton : forwardButton));
};

WizardActions.propTypes = {
  backButton: PropTypes__default['default'].string.isRequired,
  finishButton: PropTypes__default['default'].string.isRequired,
  forwardButton: PropTypes__default['default'].string.isRequired
};
var WizardActions$1 = React.memo(WizardActions);

module.exports = WizardActions$1;
